import React from 'react';
import { useAbility } from './AbilityContext';

/**
 * Can component for conditional rendering based on user permissions
 * 
 * @param {Object} props
 * @param {string} props.I - The action the user wants to perform (e.g., 'create', 'read', 'update', 'delete')
 * @param {string} props.a - The subject on which the action is performed (e.g., 'appointments', 'services')
 * @param {React.ReactNode} props.children - The content to render if the user has permission
 * @param {React.ReactNode} props.fallback - Optional content to render if the user doesn't have permission
 * @returns {React.ReactNode} - The children if the user has permission, the fallback otherwise
 */
const Can = ({ I: action, a: subject, children, fallback = null, allow = false }) => {
  const ability = useAbility();
  
  // Check if the user has permission to perform the action on the subject
  const isAllowed = allow || ability.can(action, subject);
  
  // Render the children if the user has permission, the fallback otherwise
  return isAllowed ? children : fallback;
};

export default Can;
